import React from 'react'
import { Box, Button, Typography } from '@mui/material'
import VisibilityIcon  from '@mui/icons-material/Visibility'
import LogoutIcon      from '@mui/icons-material/Logout'
import { useLocation, useNavigate } from 'react-router-dom'
import { useViewerStudent } from '../../auth/ViewAsContext'

// Persistent banner shown above content whenever staff are inside the
// /view-as/:studentId/* mirror. Renders nothing for regular students.
//
// Carries the three ways to read a student: Summary — their work as a paper,
// which is what a mentor almost always wants; Dashboard, the student's own
// view, for when the question is "what are they looking at?"; and Messages,
// the general-question exchange between them and staff.

export default function ViewAsBanner() {
  const { viewerIsStudent, studentName, prefixPath, exit } = useViewerStudent()
  const navigate = useNavigate()
  const location = useLocation()
  if (viewerIsStudent) return null

  const on = (suffix: string) => location.pathname.endsWith(suffix)

  return (
    <Box sx={{
      bgcolor:    'rgba(200,151,58,0.18)',
      borderBottom: '1px solid rgba(200,151,58,0.5)',
      px:         { xs: 2, sm: 3 },
      py:         1,
      display:    'flex',
      alignItems: 'center',
      gap:        1.5,
      flexWrap:   'wrap',
    }}>
      <VisibilityIcon fontSize="small" sx={{ color: 'secondary.main' }} />
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        Viewing as {studentName ?? 'student'}
      </Typography>

      <Box sx={{ display: 'flex', gap: 0.5 }}>
        <Button
          size="small"
          variant={on('/summary') ? 'contained' : 'text'}
          color="secondary"
          onClick={() => navigate(prefixPath('/summary'))}
        >
          Summary
        </Button>
        <Button
          size="small"
          variant={on('/dashboard') ? 'contained' : 'text'}
          color="secondary"
          onClick={() => navigate(prefixPath('/dashboard'))}
        >
          Dashboard
        </Button>
        <Button
          size="small"
          variant={on('/messages') ? 'contained' : 'text'}
          color="secondary"
          onClick={() => navigate(prefixPath('/messages'))}
        >
          Messages
        </Button>
      </Box>

      {/* Spacer. The line that used to sit here ("Read-only mirror — edits and
          submissions are disabled") was removed: it restated what the banner
          already makes obvious and cost a third of the bar to say it. */}
      <Box sx={{ flex: 1 }} />
      <Button
        size="small"
        variant="outlined"
        color="secondary"
        startIcon={<LogoutIcon />}
        onClick={exit}
      >
        Exit
      </Button>
    </Box>
  )
}
